import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, Space, theme } from 'antd';
import { RoleDto } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';

export const RoleShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<RoleDto>({ resource: 'roles' });
  const role = queryResult?.data?.data;

  if (!role) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="roles">
      <div style={{ padding: '8px 0' }}>
        <Field label="Name">{role.name}</Field>
        <Field label="Description">{role.description || '—'}</Field>
        <Field label="Permissions">
          <Space size={[4, 8]} wrap>
            {(role.permissions || []).map((p) => (
              <Tag
                key={p.id}
                style={{
                  borderColor: '#3ecf8e',
                  color: '#3ecf8e',
                  background: '#3ecf8e15',
                  borderRadius: 9999,
                  padding: '4px 12px',
                  fontSize: 12,
                }}
              >
                {p.resource}:{p.action}
              </Tag>
            ))}
          </Space>
        </Field>
      </div>
    </Show>
  );
};
